<!-- #259 -->
<template>
  <v-col :class="!isPickup ? 'mx-4' : 'px-0'">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Carrier Emails
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        dark
        class="mb-2 text-end"
        small
        v-if="checkPermission('app_pickup:add_carrier_email')"
        @click="addemail()"
        >Add New Email</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="emails"
      :loading="loader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.email`]="{ item }">
        {{ truncate(item.email, 50) }}
      </template>
      <template v-slot:[`item.contact_type`]="{ item }">
        {{ capitalizeFirstLetter(item.contact_type) }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at"
          >{{ item.created_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
          <span v-if="item.created_by"
            ><br />({{ item.created_by }})</span
          ></span
        >
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at"
          >{{ item.updated_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
          <span v-if="item.updated_by"><br />({{ item.updated_by }})</span>
        </span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span :class="item.status == 1 ? 'badge-active' : 'badge'">
          {{ item.status == 1 ? "Active" : "In-active" }}
        </span>
      </template>

      <template v-slot:top v-if="!isPickup">
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" md="3">
                <v-select
                  v-model="selectedCarriedId"
                  label="Carrier Name"
                  class="pt-0 pb-0"
                  item-text="name"
                  item-value="id"
                  hide-details
                  :items="activeCarriersListTypes"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="country_ids"
                  :items="allCountriesList"
                  label="Select Country"
                  placeholder="Start typing to Search"
                  item-text="name"
                  item-value="id"
                  outlined
                  small-chips
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-model="email_text"
                  :items="allCountriesList"
                  label="Email"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="status_text"
                  :items="statuses"
                  hide-no-data
                  item-text="text"
                  item-value="value"
                  label="Select Status"
                  outlined
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" class="text-end pr-4 mb-2">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class=""
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="checkPermission('app_pickup:carrier_email_edit')"
        >
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      max-width="650px"
      @keydown.esc="close"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >{{ formTitle }} Email
            <i class="caption red--text ml-4"> * required field</i></span
          >
        </v-card-title>
        <v-divider class="mt-3"></v-divider>
        <v-card-text class="pb-0">
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="12" md="12" class="pb-0">
                  <v-autocomplete
                    v-model="selectedAddCarriedId"
                    label="Carrier Name"
                    :rules="[(v) => !!v || 'Carriers is required.']"
                    class="required pt-0 pb-0"
                    item-text="name"
                    item-value="id"
                    :items="activeCarriersListTypes"
                    @change="getCountryList(selectedAddCarriedId)"
                    outlined
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="pb-0">
                  <v-autocomplete
                    label="Country"
                    :items="allCountries"
                    v-model="country_code"
                    item-text="country_name"
                    item-value="country_id"
                    :rules="[(v) => !!v || 'Country is required']"
                    class="required pb-0"
                    outlined
                    hide-default="auto"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="pb-0">
                  <v-text-field
                    v-model="email"
                    label="Email"
                    :rules="[
                      (v) => (v && !!v.trim()) || 'Email is required.',
                      (v) =>
                        v
                          .split(',')
                          .every((email) =>
                            /^[\w-\.]+@[\w-]+\.[\w-\.]+$/.test(email.trim())
                          ) || 'One or more emails are in an invalid format.',
                    ]"
                    class="required pb-0"
                    outlined
                    hide-default="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="status"
                    :items="statuses"
                    hide-no-data
                    item-text="text"
                    item-value="value"
                    class="required pb-0"
                    label="Select Status"
                    :rules="[
                      (v) =>
                        (v !== null && v !== undefined && v !== '') ||
                        'Status is required.',
                    ]"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-autocomplete
                    v-model="type"
                    :items="types"
                    hide-no-data
                    item-text="text"
                    item-value="value"
                    class="required"
                    label="Select Type"
                    :rules="[
                      (v) =>
                        (v !== null && v !== undefined && v !== '') ||
                        'Type is required.',
                    ]"
                    outlined
                    hide-details="auto"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row> </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="pl-8">
          <v-btn color="primary" @click="save" :loading="saveLoader">
            {{ editable === false ? "Add" : "Update" }}
          </v-btn>
          <v-btn color="primary" class="error" @click="close"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    carrierId: Number,
    isPickup: Boolean,
    countryId: Number,
  },
  computed: {
    formTitle() {
      return this.editable === false ? "Add New" : "Edit";
    },
    ...mapGetters(["activeCarriersListTypes"]),
  },
  async created() {
    this.selectedCarriedId = this.$route.params.id;
    this.getActiveCarriersListTypes();

    this.getCountries().then((res) => {
      this.allCountriesList = res.data;
    });
    if (this.isPickup) {
      this.selectedCarriedId = this.carrierId;
      this.selectedAddCarriedId = this.carrierId;
      this.country_code = this.countryId;
      this.getCountryList(this.selectedAddCarriedId);
      this.searchAll();
      // this.getEmails();
    }
  },
  data: () => ({
    email_text: "",
    status_text: "",
    allCountriesList: [],
    statuses: [
      {
        text: "Active",
        value: 1,
      },
      {
        text: "InActive",
        value: 0,
      },
    ],
    type: "",
    types: [{ text: "Pickup", value: "pickup" }],
    editedIndex: -1,
    selectedCarriedId: "",
    selectedAddCarriedId: "",
    allCountries: [],
    headers: [
      {
        text: "Carrier",
        value: "carrier_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Country",
        value: "country_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Email ID",
        value: "email",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Contact Type",
        value: "contact_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At (By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
        width: "100px",
      },
    ],
    email: "",
    options: {},
    total: 0,
    saveLoader: false,
    dialog: false,
    loader: false,
    cityLoader: false,
    countries: [],
    country_ids: [],
    status: null,
    filtersArr: [],
    selectedItem: {},
    editable: false,
    emails: [],
  }),

  watch: {
    carrierId() {
      this.selectedCarriedId = this.carrierId;
      this.searchAll();
    },
    options: {
      handler() {
        this.fetchCarrierEmail();
      },
      deep: true,
    },
    search() {
      this.fetchCarrierEmail();
    },
  },

  methods: {
    ...mapActions([
      "getCarrierEmails",
      "snackBar",
      "createCarrierEmails",
      "updateCarrierEmails",
      "getActiveCarriersListTypes",
      "getEmailDetails",
      "getPickupCountries",
      "getCountries",
    ]),
    truncate(value, limit) {
      if (!value) return "";
      return value.length > limit ? value.substring(0, limit) + "..." : value;
    },
    getCountryList(id) {
      if (id) {
        this.getPickupCountries(id).then((res) => {
          this.allCountries = res.data;
        });
      }
    },

    async fetchCarrierEmail() {
      this.emails = [];
      this.emailsLoader = true;
      let payload = {
        ...this.filtersArr,
        ...this.options,
      };
      await this.getCarrierEmails(payload)
        .then((res) => {
          this.emailsLoader = false;
          this.emails = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.emailsLoader = false;
        });
    },
    clearAll() {
      this.country_ids = [];
      this.selectedCarriedId = null;
      this.email_text = null;
      this.status_text = "";
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        carrier_id: this.selectedCarriedId,
        country_id: this.country_ids.join(","),
        email: this.email_text,
        status: this.status_text,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.list = [];
      this.options.page = 1;
      this.allFilters();
      await this.getCarrierEmails({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.emailsLoader = false;
          this.emails = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.emailsLoader = false;
        });
    },
    closeConfirm() {
      this.dialogDelete = false;
    },
    addemail() {
      this.editedIndex = -1;
      this.editable = false;
      this.dialog = true;
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      let payload = {
        carrier_id: this.selectedAddCarriedId,
        country_id: this.country_code,
        carrier_email: this.email,
        status: this.status,
        type: this.type,
      };
      if (this.editable == true) {
        this.updateCarrierEmails({
          id: this.selectedItem.id,
          data: payload,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.editedIndex = -1;

            this.fetchCarrierEmail();
          })
          .catch(() => {
            this.dialog = false;
            this.editedIndex = -1;
            this.saveLoader = false;
          });
      } else {
        let payload = {
          carrier_id: this.selectedAddCarriedId,
          country_id: this.country_code,
          carrier_email: this.email,
          status: this.status,
          type: this.type,
        };
        this.createCarrierEmails(payload)
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.fetchCarrierEmail();
          })
          .catch(() => {
            this.saveLoader = false;
            this.dialog = false;
          });
      }
    },
    editItem(item) {
      this.getEmailDetails(item.id).then(async (res) => {
        this.editable = true;
        this.selectedItem = item;
        this.email = res.data.records[0].email;
        this.status = res.data.records[0].status;
        this.selectedAddCarriedId = res.data.records[0].carrier_id;
        this.type = res.data.records[0].contact_type;

        await this.getCountryList(this.selectedAddCarriedId);
        this.country_code = res.data.records[0].country_id;
      });
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editedIndex = -1;
      this.editedAddress = {};
      if (this.isPickup) {
        this.$refs.form?.resetValidation();
      } else {
        this.$refs.form?.reset();
      }
    },
    carrierTypeList() {
      this.getCountryList(this.selectedCarriedId);
    },
  },
};
</script>
<style scoped>
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.custom-row .v-text-field input {
  flex: 1 1 auto;
  line-height: 20px;
  /* padding: 24px 0 8px; */
  max-width: 100%;
  min-width: 0px;
  width: 100%;
}
</style>
